import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import Url from '../../../apiBaseUrl/APIConfig';
import { headers } from '../../../components/Utility';
import { AddPatientDataDetailsBody, AddPatientPointDataDetails } from './Model';

// Define the state shape
export interface AddPatientPointDataState {
  addPatientDataDetailsRes: AddPatientPointDataDetails;
  loading: boolean;
  successMsg: string;
  errorMsg: string;
  status: number;
}

const initialState: AddPatientPointDataState = {
  loading: false,
  addPatientDataDetailsRes: {} as AddPatientPointDataDetails,
  successMsg: '',
  errorMsg: '',
  status: 0,
};

/**
 * Async Thunk replacing the manual API call in API.ts
 */
export const addPatientDataDetails = createAsyncThunk(
  'patientData/addDetails',
  async (payload: AddPatientDataDetailsBody, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${Url.imageUploadUrl}/adminapp/api/patientDetails/add_patientDetails_from_dashboard`,
        payload,
        { headers },
      );
      return response.data;
    } catch (error: any) {
      // Logic for extracting error message from API.ts
      const message =
        error.response?.data?.message || error.response?.data?.detail || 'Something went wrong';
      const status = error.response?.status || 0;
      return rejectWithValue({ message, status });
    }
  },
);

const addPatientDataSlice = createSlice({
  name: 'addPatientData',
  initialState,
  reducers: {
    // Replaces addPatientDataDetailsUpdateAPIResMsg
    addPatientDataDetailsUpdateAPIResMsg: (state) => {
      state.successMsg = '';
      state.errorMsg = '';
      state.status = 0;
    },
    // Replaces clearPatientDataPointClearAPIRes
    clearPatientDataPointClearAPIRes: (state) => {
      state.loading = false;
      state.addPatientDataDetailsRes = {} as AddPatientPointDataDetails;
      state.successMsg = '';
      state.errorMsg = '';
      state.status = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addPatientDataDetails.pending, (state) => {
        state.loading = true;
        state.addPatientDataDetailsRes = {} as AddPatientPointDataDetails;
      })
      .addCase(
        addPatientDataDetails.fulfilled,
        (state, action: PayloadAction<AddPatientPointDataDetails>) => {
          state.loading = false;
          state.addPatientDataDetailsRes = action.payload;
          state.successMsg = action.payload.message || 'Add Patient details successfully';
        },
      )
      .addCase(addPatientDataDetails.rejected, (state, action: any) => {
        state.loading = false;
        state.addPatientDataDetailsRes = {} as AddPatientPointDataDetails;
        state.errorMsg = action.payload?.message || 'Something went wrong';
        state.status = action.payload?.status || 0;
      });
  },
});

export const { addPatientDataDetailsUpdateAPIResMsg, clearPatientDataPointClearAPIRes } =
  addPatientDataSlice.actions;
export default addPatientDataSlice.reducer;
